import { Flex } from 'theme-ui'

export const Cta = ({ children, sx, size = 'full', ...props }) => (
  <Flex sx={{ variant: 'cta', ...sx }} data-size={size} {...props}>
    {children}
  </Flex>
)

export default Cta
